import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'accent';

/** Exported so a non-badge element (e.g. a calendar chip) can share the exact same tone colors — one place to fix for dark mode later. */
export const toneClasses: Record<BadgeTone, string> = {
  neutral: 'bg-bg text-zinc-700',
  success: 'bg-success-bg text-success-text',
  warning: 'bg-warning-bg text-warning-text',
  danger: 'bg-danger-bg text-danger-text',
  accent: 'bg-accent-soft text-link',
};

/** Status is always icon + text together, never colour alone (a11y requirement). */
export function StatusBadge({
  tone,
  icon,
  children,
}: {
  tone: BadgeTone;
  icon: string;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium',
        toneClasses[tone],
      )}
    >
      <span aria-hidden="true">{icon}</span>
      {children}
    </span>
  );
}
